<template>
  <div class="connect-ukasko-wrapper">
    <ConnectFeatures :animation-enabled="animationEnabled" />
    <Comparison :animation-enabled="animationEnabled" />
    <Possibilities :animation-enabled="animationEnabled" />
    <InterfaceSlider :animation-enabled="animationEnabled" />
    <ApiIntegration :animation-enabled="animationEnabled" />
    <FeedbacksSlider :animation-enabled="animationEnabled" v-if="false" />
    <Awards :animation-enabled="animationEnabled" />
  </div>
</template>

<script>
import ApiIntegration from './api-integration';
import Awards from './awards';
import Comparison from './comparison';
import ConnectFeatures from './connect-features';
import FeedbacksSlider from './feedbacks-slider';
import InterfaceSlider from './interface-slider';
import Possibilities from './possibilities';

export default {
  props: {
    animationEnabled: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    ConnectFeatures, Comparison, Possibilities, InterfaceSlider, ApiIntegration, FeedbacksSlider, Awards
  },
};
</script>

<style scoped lang="scss">
.connect-ukasko-wrapper {
  font-family: 'Inter', sans-serif;
  background-color: #FCFDFF;
  overflow: hidden;
}
</style>
